/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Request containing FAQ IDs in the desired display order.
 */
export interface UpdateFaqOrderRequest { 
    /**
     * FAQ IDs in the desired order.
     */
    faqIds: Array<number>;
}

